import { motion } from "framer-motion";
import { Layers, Palette, MonitorSmartphone, Component, Sparkles, Compass } from "lucide-react";

const services = [
  {
    icon: MonitorSmartphone,
    title: "Marketing websites",
    desc: "Landing pages and multi-page marketing sites that convert. Built on Framer or Webflow, or handed off to your dev team.",
  },
  {
    icon: Layers,
    title: "Product UI/UX",
    desc: "SaaS dashboards, mobile apps and internal tools — thoughtful flows, quiet visuals, high polish.",
  },
  {
    icon: Palette,
    title: "Brand identity",
    desc: "Wordmarks, systems and guidelines. A brand that scales from a favicon to a billboard.",
  },
  {
    icon: Component,
    title: "Design systems",
    desc: "Tokens, components and documentation so your team can ship faster without visual drift.",
  },
  {
    icon: Compass,
    title: "Product strategy",
    desc: "One-week sprints to sharpen positioning, flows and priorities before a single pixel gets pushed.",
  },
  {
    icon: Sparkles,
    title: "AI-native interfaces",
    desc: "Chat, agents and generative flows designed for confidence, control and clarity.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 lg:py-40 border-t border-white/5"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-4">
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-zinc-500">
              01 / Services
            </p>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-white text-balance">
              What I do, done end-to-end by one person — with taste and speed.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5 rounded-2xl overflow-hidden">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.05, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`service-card-${i}`}
              className="group bg-[#0c0c0c] hover:bg-[#111] transition-colors p-8 lg:p-10"
            >
              <s.icon className="text-indigo-400 mb-8" size={22} strokeWidth={1.5} />
              <h3 className="font-display text-xl md:text-2xl font-semibold tracking-tight text-white">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
